(() => {
  let observer, sizeObserver;
  function start() {
    observer?.disconnect(); sizeObserver?.disconnect();
    const bar = document.querySelector('.convx__sticky-atc-panel');
    function update() {
      const rect = bar?.getBoundingClientRect();
      const visible = bar && bar.classList.contains('show') && getComputedStyle(bar).display !== 'none' && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
      document.body.classList.toggle('kc-purchase-bar-visible', Boolean(visible));
      document.documentElement.style.setProperty('--kc-purchase-bar-height', visible ? `${Math.ceil(innerHeight - rect.top)}px` : '0px');
    }
    if (bar) {
      observer = new MutationObserver(update); observer.observe(bar, {attributes:true, attributeFilter:['class','style','hidden']});
      sizeObserver = new ResizeObserver(update); sizeObserver.observe(bar);
    }
    update();
  }
  start();
  document.addEventListener('shopify:section:load', start);
})();